import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Employee } from '../../../types';
import { findCodePrefix, nextSequence } from '../../../utils/codePrefixUtils';
import Input from '../../Form/Input';
import Select from '../../Form/Select';

interface EmployeeBasicInfoProps {
  register: UseFormRegister<Employee>;
  errors: FieldErrors<Employee>;
  setValue: (name: any, value: any, options?: any) => void;
  selectedCodePrefix: string;
  setSelectedCodePrefix: (value: string) => void;
  employeeNumber: string;
  setEmployeeNumber: (value: string) => void;
  codePrefixes: any[];
  rankOptions: { value: string; label: string }[];
}

const EmployeeBasicInfo: React.FC<EmployeeBasicInfoProps> = ({
  register,
  errors,
  setValue,
  selectedCodePrefix,
  setSelectedCodePrefix,
  employeeNumber,
  setEmployeeNumber,
  codePrefixes,
  rankOptions
}) => {
  return (
    <>
      <div className="col-span-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">
          Basic Information
        </h3>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Employee Code
        </label>
        <div className="flex gap-2">
          <select
            value={selectedCodePrefix}
            onChange={(e) => {
              setSelectedCodePrefix(e.target.value);
              const prefix = findCodePrefix(codePrefixes, e.target.value);
              if (prefix) {
                const nextNum = String(nextSequence(prefix)).padStart(3, '0');
                setEmployeeNumber(nextNum);
                setValue('code', `${prefix.prefix}${nextNum}`, { shouldValidate: true });
              }
            }}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="">Select Code Prefix</option>
            {codePrefixes.map((prefix: any) => (
              <option key={prefix.id} value={prefix.id}>
                {prefix.prefix} - {prefix.name}
              </option>
            ))}
          </select>
        </div>
        {selectedCodePrefix && (
          <div className="mt-2 p-2 bg-gray-50 rounded-md border border-gray-200">
            <span className="text-sm text-gray-600">Generated Code: </span>
            <span className="text-sm font-semibold text-primary-600">
              {findCodePrefix(codePrefixes, selectedCodePrefix)?.prefix}{employeeNumber}
            </span>
          </div>
        )}
        <input type="hidden" {...register('code')} />
        {errors.code?.message && (
          <p className="mt-1 text-sm text-red-600">{errors.code.message}</p>
        )}
      </div>
      
      <Input
        label="Name (English)"
        {...register('name')}
        error={errors.name?.message}
        placeholder="John Doe"
      />
      
      <Input
        label="Name (Arabic) - الاسم"
        {...register('arabicName')}
        error={errors.arabicName?.message}
        placeholder="جون دو"
        dir="rtl"
      />
      
      <Select
        label="Rank"
        {...register('rank')}
        options={rankOptions}
        error={errors.rank?.message}
      />
    </>
  );
};

export default EmployeeBasicInfo;
